import * as React from 'react';
import { ThemeModePreference, useThemeMode } from '@amzn/storm-ui';
import { logMetadata as logMetadataWithTakt } from '../utils/logWithTakt';

export default (): void => {
  const { themeModePreference, themeMode } = useThemeMode();

  React.useEffect(() => {
    const themeModeDetails = {
      themeMode,
      isSystemThemeMode: themeModePreference === ThemeModePreference.SYSTEM,
    };
    logMetadataWithTakt(themeModeDetails);
  }, []);
};
